module.exports = __webpack_public_path__ + "static/media/web_search.f5d36e16.svg";